module.exports = __webpack_public_path__ + "static/media/evz-foundation.6cf0e1aa.png";